import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import ColorPickerInput from "../../common/ColorPicker";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL, getDimension } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [headerColor, setHeaderColor] = useState("");
  const [footerColor, setFooterColor] = useState("");

  const GetEditData = async () => {
    const response = await getData(`/masters/reward-setup/${id}`);
    reset(response?.data);
    setHeaderColor(response?.data?.header_color);
    setFooterColor(response?.data?.footer_color);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    watch,
    getValues,
    formState: { errors },
    reset,
  } = useForm();

  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      console.log(data);
      const finalData = new FormData();
      // finalData.append("monthly_booking_number", data?.monthly_booking_number);
      // finalData.append("weekly_booking_number", data?.weekly_booking_number);
      // finalData.append("daily_booking_number", data?.daily_booking_number);
      finalData.append("pre_coin_rupees", data?.pre_coin_rupees);
      finalData.append("per_booking_coin_accept", data?.per_booking_coin_accept);
      finalData.append("per_booking_coin_assign", data?.per_booking_coin_assign);

      const response = await postData(`/masters/reward-setup/${id}`, finalData);
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Reward Setup
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Per Coin Rupees </Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="booking_count"
                          placeholder="Per Coin Rupees"
                          className={classNames("", {
                            "is-invalid": errors?.pre_coin_rupees,
                          })}
                          {...register("pre_coin_rupees", {
                            required: "Per Coin Rupees is required",
                          })}
                          onKeyDown={(e) => {
                            if (
                              e.key === "+" ||
                              e.key === "e" ||
                              e.key === "E" ||
                              (isNaN(Number(e.key)) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== ".") || // Allow decimal point
                              (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*\.?\d*$/.test(pasteData)) {
                              // Allow only numbers with optional single decimal
                              e.preventDefault();
                            }
                          }}
                        />
                      </InputGroup>
                      {errors.pre_coin_rupees && (
                        <span className="text-danger">
                          {errors.pre_coin_rupees.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Per Booking Coin Assign </Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="per_booking_coin_assign"
                          placeholder="Per Booking Coin Assign"
                          className={classNames("", {
                            "is-invalid": errors?.per_booking_coin_assign,
                          })}
                          {...register("per_booking_coin_assign", {
                            required: "Per Booking Coin Assign is required",
                          })}
                          onKeyDown={(e) => {
                            if (
                              e.key === "+" ||
                              e.key === "e" ||
                              e.key === "E" ||
                              (isNaN(Number(e.key)) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== ".") ||
                              (e.key === "." && e.target.value.includes("."))
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*\.?\d*$/.test(pasteData)) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </InputGroup>
                      {errors.per_booking_coin_assign && (
                        <span className="text-danger">
                          {errors.per_booking_coin_assign.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

                 <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Per Booking Coin Accept </Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="per_booking_coin_accept"
                          placeholder="Per Booking Coin Accept"
                          className={classNames("", {
                            "is-invalid": errors?.per_booking_coin_accept,
                          })}
                          {...register("per_booking_coin_accept", {
                            required: "Per Booking Coin Accept is required",
                          })}
                          onKeyDown={(e) => {
                            if (
                              e.key === "+" ||
                              e.key === "e" ||
                              e.key === "E" ||
                              (isNaN(Number(e.key)) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== ".") ||
                              (e.key === "." && e.target.value.includes("."))
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*\.?\d*$/.test(pasteData)) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </InputGroup>
                      {errors.per_booking_coin_accept && (
                        <span className="text-danger">
                          {errors.per_booking_coin_accept.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Daily Booking Number</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="daily_booking_number"
                          placeholder="Daily Booking Number"
                          className={classNames("", {
                            "is-invalid": errors?.daily_booking_number,
                          })}
                          {...register("daily_booking_number", {
                            required: "Daily Booking Number is required",
                          })}
                          onKeyDown={(e) => {
                            if (
                              e.key === "+" ||
                              e.key === "e" ||
                              e.key === "E" ||
                              (isNaN(Number(e.key)) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== ".") || // Allow decimal point
                              (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*\.?\d*$/.test(pasteData)) {
                              // Allow only numbers with optional single decimal
                              e.preventDefault();
                            }
                          }}
                        />
                      </InputGroup>
                      {errors.daily_booking_number && (
                        <span className="text-danger">
                          {errors.daily_booking_number.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Weekly Booking Number</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="booking_count"
                          placeholder="Weekly Booking Number"
                          className={classNames("", {
                            "is-invalid": errors?.weekly_booking_number,
                          })}
                          {...register("weekly_booking_number", {
                            required: "Weekly Booking Number is required",
                          })}
                          onKeyDown={(e) => {
                            if (
                              e.key === "+" ||
                              e.key === "e" ||
                              e.key === "E" ||
                              (isNaN(Number(e.key)) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== ".") || // Allow decimal point
                              (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*\.?\d*$/.test(pasteData)) {
                              // Allow only numbers with optional single decimal
                              e.preventDefault();
                            }
                          }}
                        />
                      </InputGroup>
                      {errors.weekly_booking_number && (
                        <span className="text-danger">
                          {errors.weekly_booking_number.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Monthly Booking Number</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="monthly_booking_number"
                          placeholder="Monthly Booking Number"
                          className={classNames("", {
                            "is-invalid": errors?.monthly_booking_number,
                          })}
                          {...register("monthly_booking_number", {
                            required: "Monthly Booking Number is required",
                          })}
                          onKeyDown={(e) => {
                            if (
                              e.key === "+" ||
                              e.key === "e" ||
                              e.key === "E" ||
                              (isNaN(Number(e.key)) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== ".") || // Allow decimal point
                              (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*\.?\d*$/.test(pasteData)) {
                              // Allow only numbers with optional single decimal
                              e.preventDefault();
                            }
                          }}
                        />
                      </InputGroup>
                      {errors.monthly_booking_number && (
                        <span className="text-danger">
                          {errors.monthly_booking_number.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col> */}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
